import Slideshow from './slideshow';

export default Slideshow;
